/*
 * @Date: 2023-03-03 18:43:00
 * @LastEditTime: 2023-03-13 16:34:47
 */
import React from "react";
import Clipboard from "clipboard";
import { isPC, HTTPClient } from "@weike/toolkit";
import "./style/index.css";
import config from "../../config.js";
const gwHttp = new HTTPClient({ baseURL: config.BASE_URL_ELSE }, "0000");

class OpenTips extends React.Component {
  constructor() {
    super();
    this.onClose = this.onClose.bind(this);
    this.state = { time: 3, isShow: false, canClose: false, timer: null };
  }

  componentDidMount() {
    this.onFetch();
    const timer = setInterval(() => {
      this.state.time--;
      if (this.state.time <= 0) {
        this.setState({ canClose: true });
        this.handleCopy();
        return clearInterval(timer);
      }
      this.setState({ time: this.state.time });
    }, 1000);
    this.setState({ timer });
  }

  componentWillUnmount() {
    clearInterval(this.state.timer);
  }

  onFetch() {
    const { id, type } = this.props.sharecardSlide;
    gwHttp
      .get(`/v1/integration/cont_manager/v1/api/saas/merchant.saas_info.resell.get`, {
        params: { object_id: id, object_type: type },
      })
      .then(({ data, code }) => {
        const { show_no_open_eco_tips } = data;
        if (code === "0000" && show_no_open_eco_tips) {
          this.setState({ isShow: true });
        }
      });
  }

  handleCopy() {
    let clipboard = new Clipboard("#clipBtn-OpenTips");
    clipboard.on("success", (e) => {
      this.props.page.showAlert("已复制到剪贴板");
      e.clearSelection();
    });
  }

  PcDom = () => {
    return (
      <div
        onClick={() =>
          !this.state.time &&
          window.open("https://admin.lizhiweike.com", "_blank")
        }
        className={this.state.canClose ? "btn canClose" : "btn default"}
      >
        {this.state.time ? `打开后台（${this.state.time}s）` : "打开后台"}
      </div>
    );
  };
  MobileDom = () => {
    return (
      <button
        id="clipBtn-OpenTips"
        data-clipboard-text={"https://admin.lizhiweike.com"}
        className={this.state.canClose ? "btn canClose" : "btn default"}
      >
        {this.state.time ? `复制链接（${this.state.time}s）` : "复制链接"}
      </button>
    );
  };

  onClose = () => {
    if (this.state.time) return;
    this.setState({ isShow: false });
  };

  render() {
    if (!this.state.isShow) return null;
    return (
      <div className="openTips">
        <div className="box">
          <div className="content-box">
            <div className="title">邀请奖励说明</div>
            <div className="note">
              <div>
                尊敬的用户，为了满足国家相关监管规定及微信官方规则，我们需要您尽快登录荔课电脑端后台
              </div>
              <div className="red">admin.lizhiweike.com</div>
              <div>
                更新您的收款信息以供平台及微信官方审查。
                <span className="red">
                  如果您未更新收款信息，将无法通过邀请获得奖励收益。
                </span>
              </div>
              <div className="footer">
                如有疑问，您可在荔课微信公众号内回复：客服，了解详情。
              </div>
            </div>

            {isPC() ? this.PcDom() : this.MobileDom()}
          </div>
          <div className="img-box" onClick={this.onClose}>
            {!this.state.time && (
              <img
                className="img"
                src="https://staticqc-operating.lycheer.net/image/weike-SDEHdR-445020858.png"
                alt=""
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default OpenTips;



// WEBPACK FOOTER //
// ./src/components/openTips/index.js